<ngx-spinner type="ball-spin"></ngx-spinner>
<router-outlet *ngIf="showRouterOutlet"></router-outlet>
